import React, { type FC } from "react";
import { BusinessList } from "@src/components/business-list";
import { BusinessMeasureValue, BusinessStockObjValue } from "@src/components/business-data-display";
import { ListItem } from "@src/components/business-list";
import type { UseWsInvActContentsQueryResult } from "../../hooks/useWsInvActContentsQuery";

interface WsInvContentsListProps {
    contentsQuery: UseWsInvActContentsQueryResult;
    onOpenContent: (contentCode: number) => void;
    onOpenSearch: () => void;
}

/**
 * Список состава акта инвентаризации УП.
 */
export const WsInvContentsList: FC<WsInvContentsListProps> = ({ contentsQuery, onOpenContent, onOpenSearch }) => {
    const { content, isFetching } = contentsQuery;

    return (
        <BusinessList
            isLoad={isFetching}
            hoodBtns={[
                {
                    text: "Найти",
                    srcIcon: "/images/common/loupe.svg",
                    onClick: onOpenSearch,
                },
            ]}
        >
            {content.map((item) => (
                <ListItem
                    key={item.Code}
                    title={<BusinessStockObjValue stockObj={item.WsDepotCard?.Stockobj} />}
                    props={[
                        {
                            label: "Количество факт",
                            value: <BusinessMeasureValue value={item.FactQty} measure={item.WsDepotCard?.Measure} />,
                        },
                    ]}
                    onClick={() => {
                        onOpenContent(item.Code);
                    }}
                />
            ))}
        </BusinessList>
    );
};
